/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-actions/content-control-studio-action-button/content-control-studio-action-button.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  -webkit-user-select: none;
  user-select: none;
}
.button-container {
  background: #ebf0f4;
  border-radius: 3.13px;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.button-container ::ng-deep img,
.button-container ::ng-deep svg {
  width: 24px;
  height: 24px;
  position: relative;
  background-color: transparent;
}
/*# sourceMappingURL=content-control-studio-action-button.component.css.map */
